import React from "react";



import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import BusisnessRisk2 from "pages/AllCharts2/apex2/BusisnessRisk2";
import FinancialRisk2 from "pages/AllCharts2/apex2/FinancialRisk2";
import IndustryRisk2 from "pages/AllCharts2/apex2/IndustryRisk2";
import OverAllRisk2 from "pages/AllCharts2/apex2/OverAllRisk2";

const Apexchart2 = () => {
  document.title = "Apex Charts | Bvo -Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Bvo" title="Charts" breadcrumbItem="Apex Charts" />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Business Risk</h4>
                  <BusisnessRisk2/>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Financial Risk</h4>
                  <FinancialRisk2/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Industry Risk</h4>
                  <IndustryRisk2/>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Over All Risk</h4>
                  <OverAllRisk2/>
                </CardBody>
              </Card>
            </Col>
          </Row>
      
        </div>
      </div>
    </React.Fragment>
  );
};

export default Apexchart2;
